import React from 'react';
import GreenUpIcon from '@/pages/strategic/assests/svg/green-up.svg';
import RedDownIcon from '@/pages/strategic/assests/svg/red-down.svg';
import './index.scss';

interface IYoyMomDisplayProps {
  date?: string | null;
  value: number | null | undefined;
  type: 'yoy' | 'mom';
}

const YoyMomDisplay: React.FC<IYoyMomDisplayProps> = ({ date, value, type }) => {
  const formatDateComparison = (dateStr: string | null | undefined, comparisonType: 'yoy' | 'mom'): string => {
    if (!dateStr) return '';
    
    const [year, month] = dateStr.split('-');
    const currentYear = parseInt(year);
    const currentMonth = parseInt(month);
    
    if (comparisonType === 'yoy') {
      // YOY: Compare with same month previous year
      const prevYear = currentYear - 1;
      return `${prevYear}-${month} VS ${year}-${month}`;
    } else {
      // MOM: Compare with previous month same year
      const prevMonth = currentMonth - 1;
      const prevMonthStr = prevMonth > 0 ? String(prevMonth).padStart(2, '0') : '12';
      const prevYear = prevMonth > 0 ? currentYear : currentYear - 1;
      return `${prevYear}-${prevMonthStr} VS ${year}-${month}`;
    }
  };

  const displayValue = value !== undefined && value !== null ? `${Math.abs(value).toFixed(1)}%` : '-';
  const showIcon = value !== undefined && value !== null && value !== 0;

  return (
    <>
      <div className='dbs-revenue-date-desc dbs-yoy-mom-date'>
        {formatDateComparison(date, type)}
      </div>
      <div className='dbs-yoy-mom-value-wrapper'>
        <span className='dbs-yoy-mom-value'>
          {displayValue}
        </span>
        {showIcon && (
          <img 
            src={value > 0 ? GreenUpIcon : RedDownIcon} 
            alt={value > 0 ? 'up' : 'down'}
            className='dbs-yoy-mom-icon'
          />
        )}
      </div>
    </>
  );
};

export default YoyMomDisplay;

